import React, { useState, useEffect } from 'react';
import UI_Icon from './ERUMAUI/UI_Icons';
import { Test_Connection } from '../api/API_Tester';
import { NetworkEvents } from '../api/API';

export default function Overlay_Errors() {
    const [Error_Internet, Error_Internet_Set] = useState(false);

    useEffect(() => {
        const handleOnline = () => Error_Internet_Set(false);
        const handleOffline = () => Error_Internet_Set(true);

        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        NetworkEvents.on("Network_Error", handleOffline);
        NetworkEvents.on("Network_Online", handleOnline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
            NetworkEvents.off("Network_Error", handleOffline);
            NetworkEvents.off("Network_Online", handleOnline);
        };
    }, []);

    useEffect(() => {
        const Connection_Check = async () => {
            try {
                const Control = new AbortController();
                const Timeout = setTimeout(() => Control.abort(), 2500);
                await Test_Connection();
                clearTimeout(Timeout);
                Error_Internet_Set(false);
            } catch (Error) {
                Error_Internet_Set(true);
            }
        }
        Connection_Check();
        const Interval = setInterval(Connection_Check, 5000);
        return () => clearInterval(Interval);
    }, []);
    return (
        <div className="Overlay_Errors" State={Error_Internet ? "Active" : "Inactive"} >
            <div className="Overlay_Error">
                <UI_Icon Name="Error" />
                <p className='Overlay_Error_Text'>
                    No or slow internet connection.
                </p>
            </div>
        </div>
    );
}
